export default "__VITE_ASSET__DrVrCrkd__"